




































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { firebaseDB } from '@/firebase';
import SearchableTable, {
  SearchableField
} from '@/components/SearchableTable.vue';
import AutocompleteInput from '@/components/AutocompleteInput.vue';
import Multiselect from 'vue-multiselect';
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/lib/vue-daterange-picker.min.css';
import moment from 'moment-timezone';
import constants from '@/utils/constants';

export class Transaction {
  public date: string = '';
  public userId: string = '';
  public rscName: string = '';
  public regionalName: string = '';
  public areaName: string = '';
  public outletCode: string = '';
  public transactionType: string = '';
  public paymentChannel: string = '';
  public totalAmount: number = 0;
  public orderStatus: string = '';
  public sendStatus: string = '';
}

@Component
class TransactionSearchableTable extends SearchableTable<Transaction> {
  filterUserId: string = '';
  filterPeriodStart: string = '';
  filterPeriodEnd: string = '';
  filterRsc: any = '';
  filterRegional: any = '';
  filterArea: any = '';
  filterStore: any = '';
  filterOrderType: any = '';
  filterPaymentChannel: any = '';
  filterOrderStatus: any = '';
  filterSendToPosStatus: any = '';

  public createItem(data: any): Transaction {
    const ret = new Transaction();
    let date: string = '';
    if (data.createdDate && moment(data.createdDate).isValid()) {
      date = moment
        .unix(data.createdDate)
        .utc()
        .format('DD-MM-YYYY HH:mm');
    }
    if (data.CreatedDate && moment(data.CreatedDate).isValid()) {
      date = moment
        .unix(data.CreatedDate)
        .utc()
        .format('DD-MM-YYYY HH:mm');
    }

    ret.date = date;
    ret.userId = data.user ? data.user.id : '';
    ret.rscName = data.destinationStore
      ? data.destinationStore.regionCode
      : data.DestinationStore.RSCCode;
    ret.regionalName = data.destinationStore
      ? data.destinationStore.regionalName
      : data.DestinationStore.RegionalName;
    ret.areaName = data.deliveryAddress
      ? data.deliveryAddress.areaName
      : data.DestinationStore.AreaName;
    ret.outletCode = data.destinationStore
      ? data.destinationStore.outletCode
      : data.DestinationStore.OutletCode;
    ret.transactionType = data.orderType ? data.orderType : data.OrderType;
    ret.paymentChannel = data.payment
      ? data.payment.paymentMethodCode
      : data.PaymentMethod;
    ret.totalAmount = data.totalAmount ? data.totalAmount : data.TotalAmount;
    ret.orderStatus = data.orderStatus ? data.orderStatus : data.Status;
    ret.sendStatus = data.transferStatus
      ? data.transferStatus
      : data.TransferStatus;
    return ret;
  }

  multipleFilter(facetName: string, data: string): string {
    let dataArray: string[] = data.split(',');
    let multipleFilterQuery: string = '';
    if (dataArray && dataArray.length > 0) {
      dataArray.forEach((item, index) => {
        if (index === 0) {
          multipleFilterQuery = item;
        } else {
          multipleFilterQuery =
            multipleFilterQuery + ' OR ' + facetName + ':' + item;
        }
      });
    }

    return multipleFilterQuery;
  }

  query() {
    this.pageIsBusy = true;

    const filters: any[] = [];

    if (this.filterUserId) {
      filters.push(`user.id:${this.filterUserId}`);
    }
    if (this.filterPeriodStart && this.filterPeriodEnd) {
      filters.push(`createdDate >= ${this.filterPeriodStart}`);
      filters.push(`createdDate <= ${this.filterPeriodEnd}`);
    }
    if (this.filterRsc) {
      filters.push(`destinationStore.regionCode:${this.filterRsc}`);
    }
    if (this.filterRegional) {
      filters.push(`destinationStore.regionalName:${this.filterRegional}`);
    }
    if (this.filterArea) {
      filters.push(`deliveryAddress.areaName:${this.filterArea}`);
    }
    if (this.filterStore) {
      filters.push(`destinationStore.outletCode:${this.filterStore}`);
    }
    if (this.filterOrderType) {
      const filterOrderType: string = this.multipleFilter(
        'OrderType',
        this.filterOrderType
      );
      filters.push(`orderType:${filterOrderType}`);
    }
    if (this.filterPaymentChannel) {
      filters.push(`payment.paymentMethodCode:${this.filterPaymentChannel}`);
    }
    if (this.filterOrderStatus) {
      filters.push(`orderStatus:${this.filterOrderStatus}`);
    }
    if (this.filterSendToPosStatus) {
      filters.push(`transferStatus:${this.filterSendToPosStatus}`);
    }

    this.algoliaIndex.setSettings({
      searchableAttributes: [
        'createdDate',
        'createdDateReadable',
        'user.id',
        'destinationStore.regionCode',
        'destinationStore.regionalName',
        'deliveryAddress.areaName',
        'destinationStore.outletCode',
        'orderType',
        'payment.paymentMethodCode',
        'totalAmount',
        'orderStatus',
        'transferStatus'
      ],
      attributesForFaceting: [
        'createdDate',
        'createdDateReadable',
        'user.id',
        'destinationStore.regionCode',
        'destinationStore.regionalName',
        'deliveryAddress.areaName',
        'destinationStore.outletCode',
        'orderType',
        'payment.paymentMethodCode',
        'totalAmount',
        'orderStatus',
        'transferStatus'
      ]
    });

    this.algoliaIndex
      .search({
        query: this.searchKeyword,
        typoTolerance: false,
        facetFilters: filters,
        page: this.currentPage - 1,
        hitsPerPage: this.perPage
      })
      .then(resp => {
        this.items = resp.hits.map(v => this.createItem(v));
        this.totalRows = resp.nbHits;

        this.pageIsBusy = false;
      })
      .catch(err => {
        console.error(err);

        this.items = [];

        this.pageIsBusy = false;
      });
  }
}

@Component({
  components: {
    TransactionSearchableTable,
    AutocompleteInput,
    Multiselect,
    DateRangePicker
  }
})
export default class Transactions extends Vue {
  public fieldsSet: Array<SearchableField> = [
    SearchableField.FromObject({
      key: 'date',
      label: 'Date and Time'
    }),
    SearchableField.FromObject({
      key: 'userId',
      label: 'User ID'
    }),
    SearchableField.FromObject({
      key: 'rscName',
      label: 'RSC Code'
    }),
    SearchableField.FromObject({
      key: 'regionalName',
      label: 'Regional Name'
    }),
    SearchableField.FromObject({
      key: 'areaName',
      label: 'Area Name'
    }),
    SearchableField.FromObject({
      key: 'outletCode',
      label: 'Outlet Code'
    }),
    SearchableField.FromObject({
      key: 'transactionType',
      label: 'Transactions Type'
    }),
    SearchableField.FromObject({
      key: 'paymentChannel',
      label: 'Payment Channel'
    }),
    SearchableField.FromObject({
      key: 'totalAmount',
      label: 'Total Amount'
    }),
    SearchableField.FromObject({
      key: 'orderStatus',
      label: 'Order Status'
    }),
    SearchableField.FromObject({
      key: 'sendStatus',
      label: 'Send Status'
    })
  ];

  // data
  isLoading: boolean = false;
  rscs: any[] = [];
  regionals: any[] = [];
  areas: any[] = [];
  stores: any[] = [];
  orderTypes: any[] = [
    {
      value: '',
      text: 'All'
    },
    {
      value: 'HomeDelivery,PayNPick',
      text: 'Home Delivery + Pay and Pick'
    },
    {
      value: constants.HMD,
      text: 'Home Delivery'
    },
    {
      value: 'QRPay',
      text: 'QR Pay'
    }
  ];
  paymentChannels: any[] = [
    {
      value: '',
      text: 'All'
    },
    {
      value: 'Non-Cash',
      text: 'Non-Cash'
    },
    {
      value: 'DANA_CC',
      text: 'DANA_CC'
    },
    {
      value: 'DANA_DC',
      text: 'DANA_DC'
    },
    {
      value: 'DANA',
      text: 'DANA'
    },
    {
      value: 'Cash',
      text: 'Cash'
    }
  ];
  orderStatuses: any[] = [
    {
      value: '',
      text: 'All'
    },
    {
      value: 'SUCCESS',
      text: 'SUCCESS'
    },
    {
      value: constants.UPPER_CANCELLED,
      text: constants.UPPER_CANCELLED
    },
    {
      value: 'INIT',
      text: 'INIT'
    },
    {
      value: 'TRANSFERRED',
      text: 'TRANSFERRED'
    },
    {
      value: 'FAIL_CREATE_ORDER',
      text: 'FAIL_CREATE_ORDER'
    },
    {
      value: 'EXPIRED',
      text: 'EXPIRED'
    },
    {
      value: 'ON_DELIVERY',
      text: 'ON_DELIVERY'
    },
    {
      value: 'PAYMENT_SUCCESS',
      text: 'PAYMENT_SUCCESS'
    },
    {
      value: 'COMPLETED',
      text: 'COMPLETED'
    }
  ];
  sendToPosStatuses: any[] = [
    {
      value: '',
      text: 'All'
    },
    {
      value: 'ONLINE',
      text: 'ONLINE'
    },
    {
      value: 'OFFLINE',
      text: 'OFFLINE'
    },
    {
      value: 'SUCCESS',
      text: 'SUCCESS'
    },
    {
      value: 'INIT',
      text: 'INIT'
    },
    {
      value: 'SEND_FAX',
      text: 'SEND_FAX'
    }
  ];
  ranges: any = {
    Today: [moment(), moment()],
    Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
    'This month': [moment().startOf('month'), moment().endOf('month')],
    'This year': [moment().startOf('year'), moment().endOf('year')],
    'Last week': [
      moment()
        .subtract(1, 'week')
        .startOf('week'),
      moment()
        .subtract(1, 'week')
        .endOf('week')
    ],
    'Last month': [
      moment()
        .subtract(1, 'month')
        .startOf('month'),
      moment()
        .subtract(1, 'month')
        .endOf('month')
    ]
  };

  isInvalidUserId: boolean = false;
  isInvalidPeriod: boolean = false;
  filterUserId: string = '';
  filterPeriodStart: string = moment().toString();
  filterPeriodEnd: string = moment().toString();
  filterPeriod: string = '-';
  filterRsc: any = { value: '', text: 'All' };
  filterRegional: any = { value: '', text: 'All' };
  filterArea: any = { value: '', text: 'All' };
  filterStore: any = { value: '', text: 'All' };
  filterOrderType: any = { value: '', text: 'All' };
  filterPaymentChannel: any = { value: '', text: 'All' };
  filterOrderStatus: any = { value: '', text: 'All' };
  filterSendToPosStatus: any = { value: '', text: 'All' };
  transactions!: Transaction[];

  // watch
  @Watch('filterUserId')
  watchFilterUserId() {
    this.isInvalidUserId =
      this.filterUserId.length > 0 && this.filterUserId.length < 9;
  }

  // mounted
  mounted() {
    this.getRsc();
    this.getRegionals();
    this.getAreas();
    this.getStores();
  }

  // methods
  getRsc() {
    const rscs = firebaseDB.collection('RSC');
    rscs.onSnapshot(snap => {
      this.rscs = [
        {
          value: '',
          text: 'All'
        }
      ];
      snap.forEach(rsc => {
        this.rscs.push({
          value: rsc.data().Code,
          text: rsc.data().Name
        });
      });
    });
    return this.rscs;
  }
  getRegionals() {
    const regionals = firebaseDB.collection('Regional');
    regionals.onSnapshot(snap => {
      this.regionals = [
        {
          value: '',
          text: 'All'
        }
      ];
      snap.forEach(regional => {
        this.regionals.push({
          value: regional.data().Code,
          text: regional.data().Name
        });
      });
    });
    return this.regionals;
  }
  getAreas() {
    const areas = firebaseDB.collection('Area');
    areas.onSnapshot(snap => {
      this.areas = [
        {
          value: '',
          text: 'All'
        }
      ];
      snap.forEach(area => {
        this.areas.push({
          value: area.data().Code,
          text: area.data().Name
        });
      });
    });
    return this.areas;
  }
  getStores() {
    const stores = firebaseDB.collection('Store');
    stores.onSnapshot(snap => {
      this.stores = [
        {
          value: '',
          text: 'All'
        }
      ];
      snap.forEach(store => {
        this.stores.push({
          value: store.data().OutletCode,
          text: store.data().OutletCode
        });
      });
    });
    return this.stores;
  }
  setUserId(text: string) {
    this.filterUserId = text;
  }
  setPeriod(data: any) {
    this.filterPeriodStart = data.startDate ? data.startDate : '';
    this.filterPeriodEnd = data.endDate ? data.endDate : '';
    this.filterPeriod = `${this.formatDate(
      this.filterPeriodStart
    )} - ${this.formatDate(this.filterPeriodEnd)}`;

    // validation
    if (
      moment(this.filterPeriodStart).isValid() ||
      moment(this.filterPeriodEnd).isValid()
    ) {
      this.isInvalidPeriod =
        moment(this.filterPeriodEnd).diff(
          moment(this.filterPeriodStart),
          'years'
        ) > 0;
    }
  }
  formatDate(val: any) {
    let date: any = val;
    if (moment(date).isValid()) {
      date = moment(date).format('DD-MM-YYYY');
    }
    return date;
  }
  resetFilter() {
    this.filterUserId = '';
    this.filterRsc = { value: '', text: 'All' };
    this.filterRegional = { value: '', text: 'All' };
    this.filterArea = { value: '', text: 'All' };
    this.filterStore = { value: '', text: 'All' };
    this.filterOrderType = { value: '', text: 'All' };
    this.filterPaymentChannel = { value: '', text: 'All' };
    this.filterOrderStatus = { value: '', text: 'All' };
    this.filterSendToPosStatus = { value: '', text: 'All' };
    this.filterPeriodStart = moment().toString();
    this.filterPeriodEnd = moment().toString();
    this.filterPeriod = '-';
    this.$refs.searchableTable!['searchKeyword'] = '';

    // set value autoSuggest
    let refAutocompleteInput = this.$refs.setValue as AutocompleteInput;
    refAutocompleteInput.resetValue();
    const table = this.$refs.searchableTable as TransactionSearchableTable;

    table.filterUserId = this.filterUserId;
    table.filterRsc = this.filterRsc.value;
    table.filterRegional = this.filterRegional.value;
    table.filterArea = this.filterArea.value;
    table.filterStore = this.filterStore.value;
    table.filterOrderType = this.filterOrderType.value;
    table.filterPaymentChannel = this.filterPaymentChannel.value;
    table.filterOrderStatus = this.filterOrderStatus.value;
    table.filterSendToPosStatus = this.filterSendToPosStatus.value;
    let startDate = moment(
      moment(this.filterPeriodStart).format('YYYY-MM-DD')
    ).format('X');
    let endDate = moment(
      moment(this.filterPeriodEnd).format('YYYY-MM-DD 23:59:59')
    ).format('X');
    table.filterPeriodStart = this.filterPeriod !== '-' ? startDate : '';
    table.filterPeriodEnd = this.filterPeriod !== '-' ? endDate : '';
    table.query();
  }
  doSearch() {
    const table = this.$refs.searchableTable as TransactionSearchableTable;

    table.filterUserId = this.filterUserId;
    table.filterRsc = this.filterRsc.value;
    table.filterRegional = this.filterRegional.value;
    table.filterArea = this.filterArea.value;
    table.filterStore = this.filterStore.value;
    table.filterOrderType = this.filterOrderType.value;
    table.filterPaymentChannel = this.filterPaymentChannel.value;
    table.filterOrderStatus = this.filterOrderStatus.value;
    table.filterSendToPosStatus = this.filterSendToPosStatus.value;
    let startDate = moment(
      moment(this.filterPeriodStart).format('YYYY-MM-DD')
    ).format('X');
    let endDate = moment(
      moment(this.filterPeriodEnd).format('YYYY-MM-DD 23:59:59')
    ).format('X');
    table.filterPeriodStart = this.filterPeriod !== '-' ? startDate : '';
    table.filterPeriodEnd = this.filterPeriod !== '-' ? endDate : '';
    table.query();
  }
}
